import { gql } from '@apollo/client';


export const ADD_OR_UPDATE_NIC_ENTRY = gql`
  mutation addOrUpdateNicEntryInIncident($input: AddOrUpdateNicEntryInIncidentInput!) {
    addOrUpdateNicEntryInIncident(input: $input) {
      clientMutationId
      errors
      incidentUuid
      nicEntryUuid
      nicEntry {
        cancelled
        id
        incidentId
        mriNumber
        narrative
        nicNumber
        uuid
      }
    }
  }
`

